import React, { Component } from 'react'
import Text from '../../components/Text.js'
import Button from '../../components/Button.js'
import Icon from '../../components/Icon.js'
import history from '../../history.js'
import { withTranslation } from 'react-i18next'
import { format, isAfter, startOfDay } from 'date-fns'
import './Info.css'
import LoadImage from '../../components/LoadImage.js'
import getContacts from '../../getContacts.js'
import AddPicturesToPlanning from '../../components/AddPicturesToPlanning/AddPicturesToPlanning.js'
import convertTimezone from '../../convertTimezone.js'

class Info extends Component {
  constructor(props) {
    super(props)

    this.state = { showMapPicker: false }

    this.handleCommentClick = this.handleCommentClick.bind(this)
    this.handleAddressClick = this.handleAddressClick.bind(this)
    this.handleMapPickerClose = this.handleMapPickerClose.bind(this)
  }

  handleAddressClick(e) {
    this.setState({ showMapPicker: true })
  }

  handleMapPickerClose(e) {
    this.setState({ showMapPicker: false })
  }

  handleCommentClick(e) {
    history.push(`/job/${this.props.planning.seqplan}/comment`)
  }

  handleCommentEditClick(comment) {
    return e => {
      history.push(`/job/${this.props.planning.seqplan}/editComment/${comment.seqopm}`)
    }
  }

  handleImageClick(image) {
    return e => {
      history.push(`/image/${this.props.planning.seqplan}/${image.seqafb}`)
    }
  }

  render() {
    const {
      planning,
      t,
      gotoBill
    } = this.props
    const { showMapPicker } = this.state
    const address = `${planning.werk?.werf?.gemeente || ''}, ${planning.werk?.werf?.straat || ''} ${planning.werk?.werf?.nummer || ''}`
    const werkDetail = planning.werk?.details || []
    const drillDetail = werkDetail.filter(work => (work.typewerk || 'B').toUpperCase() === 'B')
    const sawDetail = werkDetail.filter(work => (work.typewerk || '').toUpperCase() === 'Z')
    const comments = planning.opmerkingen || []
    const contacts = getContacts(planning)
    const workers = planning.werk?.workers || []
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${window.encodeURIComponent(address)}`
    const wazeUrl = `https://waze.com/ul?q=${window.encodeURIComponent(address)}`
    const isFinished = planning.uitgevoerd
    const images = (planning.images || []).filter(image => !image.bij_opmerking)
    const planningVanDate = convertTimezone(new Date(planning.van))
    const planningTotDate = convertTimezone(new Date(planning.tot))
    const isFuture = isAfter(startOfDay(planningVanDate), startOfDay(new Date()))

    return (
      <>
        {showMapPicker && (
          <div className="Job-map-picker-overlay" onClick={this.handleMapPickerClose}>
            <div className="Job-map-picker" onClick={e => e.stopPropagation()}>
              <div className="Job-map-picker-address"><Text color="dark" size="small">{address}</Text></div>
              <a className="Job-map-picker-option Job-a" href={googleMapsUrl} rel="noopener noreferrer" target="_blank" onClick={this.handleMapPickerClose}>
                <Text color="dark" weight="bold">{t('open_in_google_maps')}</Text>
              </a>
              <a className="Job-map-picker-option Job-a" href={wazeUrl} rel="noopener noreferrer" target="_blank" onClick={this.handleMapPickerClose}>
                <Text color="dark" weight="bold">{t('open_in_waze')}</Text>
              </a>
              <button className="Job-map-picker-cancel" onClick={this.handleMapPickerClose}>
                <Text color="light">{t('cancel')}</Text>
              </button>
            </div>
          </div>
        )}
        <div>
          <button className="Job-info-row Job-info-row-button" onClick={this.handleAddressClick}>
            <div className="Job-info-row-icon"><Icon fill="var(--grey-dark)" name="pin" /></div>
            <div className="Job-info-row-label"><Text color="dark">{address}</Text></div>
            <div className="Job-info-row-icon"><Icon fill="var(--orange)" name="navigation" /></div>
          </button>
          <div className="Job-info-row">
            <div className="Job-info-row-icon"><Icon fill="var(--grey-dark)" name="clock" /></div>
            <div className="Job-info-row-label"><Text color="dark">{format(planningVanDate, 'HH:mm')} - {format(planningTotDate, 'HH:mm')}</Text></div>
          </div>
          <div className="Job-info-columns">
            <Button onClick={gotoBill}>
              <div className="Job-info-row-grow">
                <div className="Job-info-row-icon"><Icon fill="var(--purple)" name="drill" width={20} height={20} /></div>
                <div className="Job-info-row-label Job-info-row-label-column">
                  {
                    drillDetail.map(detail => {
                      return (
                        <Text key={detail.id} color="purple" weight="bold">{detail.aantal || '?'} {detail.positie?.positie_code || '?'} {detail.diameter || '?'} {detail.diepte || '?'}</Text>
                      )
                    })
                  }
                </div>
              </div>
            </Button>
            <Button onClick={gotoBill}>
              <div className="Job-info-row-grow">
                <div className="Job-info-row-icon"><Icon fill="var(--blue)" name="saw" width={20} height={20} /></div>
                <div className="Job-info-row-label Job-info-row-label-column">
                  {
                    sawDetail.map(detail => {
                      return (
                        <Text key={detail.id} color="blue" weight="bold">{detail.aantal || '?'} {detail.positie?.positie_code || '?'} {detail.lengte || '?'} {detail.diepte || '?'}</Text>
                      )
                    })
                  }
                </div>
              </div>
            </Button>
          </div>
          <div className="Job-info-row">
            <div className="Job-info-row-icon"><Icon fill="var(--grey-dark)" name="write" width={14} height={14} /></div>
            <div className="Job-info-row-label"><Text color="dark" size="small">{planning.werk?.opmerking}</Text></div>
          </div>
          {
            contacts.map(contact => {
              return (
                <a className="Job-info-row Job-a" key={contact.id} href={`tel:${contact.telefoon || ''}`}>
                  <div className="Job-info-row-icon"><Icon fill="var(--grey-dark)" name="manager" width={18} height={18} /></div>
                  <div className="Job-info-row-label"><Text color="dark">{contact.naam || ''}</Text></div>
                  <div className="Job-info-row-label Job-info-row-label-right"><Text color="dark" size="small">{contact.telefoon || ''}</Text></div>
                  <div className="Job-info-row-icon"><Icon fill="var(--orange)" name="phone" /></div>
                </a>
              )
            })
          }
          {
            workers.map(worker => {
              const mobile = worker.mobile || ''
              return (
                <div className="Job-info-row" key={worker.seqpers}>
                  <div className="Job-info-row-icon"><Icon fill="var(--grey-dark)" name="worker" /></div>
                  <div className="Job-info-row-label"><Text color="dark">{`${worker.voornaam || ''} ${worker.achternaam || ''}`}</Text></div>
                  <div className="Job-info-row-label Job-info-row-label-right"><Text color="dark" size="small">{mobile}</Text></div>
                  {mobile && <div className="Job-info-row-icon"><a className="Job-a" href={`tel:${mobile}`}><Icon fill="var(--orange)" name="phone" /></a></div>}
                </div>
              )
            })
          }
        </div>
        <div className="Job-pictures">
          {images.map(image => {
            return (
              <div key={image.seqafb} className="Job-picture-container">
                <Button onClick={this.handleImageClick(image)}>
                  <LoadImage seqafb={image.seqafb} />
                </Button>
              </div>
            )
          })}
        </div>
        <div className="Job-comments">
          {
            comments.map(comment => {
              return (
                <Button key={comment.seqopm} onClick={isFuture ? () => { } : this.handleCommentEditClick(comment)}>
                  <div className="Job-comment">
                    <div className="Job-comment-icon"><Icon name="comment" fill="var(--grey-dark)" /></div>
                    <div className="Job-comment-text"><Text color="dark">{comment.opmerking}</Text></div>
                    <div className="Job-comment-icon"><Icon fill="var(--orange)" name="pencil" width={14} height={14} /></div>
                  </div>
                </Button>
              )
            })
          }
        </div>
        <div className="Job-footer-button-container">
          {isFuture
            ? null
            : isFinished
              ? <AddPicturesToPlanning planning={planning} />
              : <>
                <Button color="orange" onClick={this.handleCommentClick}>
                  <div className="Job-footer-button">
                    <Icon name="comment" fill="white" width={16} height={16} />
                    <Text color="white" weight="bold">{t('add_comment')}</Text>
                  </div>
                </Button>
              </>
          }
        </div>
      </>
    )
  }
}

const InfoWithT = withTranslation()(Info)

export default InfoWithT
